import { useState } from "react";
import { ReservationSaveMapping } from "../../../Services/Service";
import swal from "sweetalert";
import { useProperty } from "../../../PropertyContext";
import '../PropertyDetails.css';

export const AddRateInventory = ({ Pms, ratecode, mealplan, rooms, onSaveSuccess, modalId }) => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);

    const [selectedRate, setSelectedRate] = useState("");
    const [selectedMealPlan, setSelectedMealPlan] = useState("");
    const [effectiveFrom, setEffectiveFrom] = useState("");
    const [effectiveTo, setEffectiveTo] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [roomRates, setRoomRates] = useState({});

    const resetForm = () => {
        setSelectedRate("");
        setSelectedMealPlan("");
        setEffectiveFrom("");
        setEffectiveTo("");
        setIsActive(true);
        setRoomRates({});
    };

    const handleRateChange = (roomId, field, value) => {
        setRoomRates((prev) => ({
            ...prev,
            [roomId]: {
                ...prev[roomId],
                [field]: value,
            },
        }));
    };

    // const handleSubmit = async () => {
    //     if (!selectedMealPlan) {
    //         swal("Error", "Please select Meal Plan", "error");
    //         return;
    //     }

    //     // Sirf woh rooms jinka koi bhi rate fill kiya ho
    //     const filledRooms = rooms.filter((room) => {
    //         const rates = roomRates[room.RoomID];
    //         return rates && Object.values(rates).some((v) => v !== "" && v !== undefined);
    //     });

    //     if (filledRooms.length === 0) {
    //         swal("Error", "Please fill rates for at least one room", "error");
    //         return;
    //     }

    //     try {
    //         setLoading(true);

    //         // Har room ke liye alag API call - parallel
    //         const promises = filledRooms.map((room) => {
    //             const rates = roomRates[room.RoomID] || {};
    //             return ReservationSaveMapping(
    //                 selectedProperty?.PropertyID || 0,
    //                 0,                          // editId = 0 (new record)
    //                 selectedRate || 0,
    //                 selectedMealPlan,
    //                 room.RoomID,                // har room ka ID
    //                 rates.BaseRate || 0,
    //                 rates.DoubleRate || 0,
    //                 rates.TripleRate || 0,
    //                 rates.ExtraBed || 0,
    //                 rates.ExtraAdultRate || 0,
    //                 rates.ExtraChildRate || 0,
    //                 effectiveFrom,
    //                 effectiveTo,
    //                 isActive ? 1 : 0
    //             );
    //         });

    //         await Promise.all(promises);

    //         if (onSaveSuccess) await onSaveSuccess();

    //         swal("Data Saved Successfully", {
    //             icon: "success",
    //             buttons: { confirm: { text: "OK", className: "btn btn-success" } },
    //         }).then(() => {
    //             const modal = window.bootstrap.Modal.getInstance(
    //                 document.getElementById(modalId)
    //             );
    //             if (modal) modal.hide();
    //             resetForm();
    //         });

    //     } catch (error) {
    //         console.log("Error saving mapping", error);
    //         swal("Failed to save data!", { icon: "error" });
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const handleSubmit = async () => {
        if (!selectedMealPlan) {
            swal("Error", "Please select Meal Plan", "error");
            return;
        }

        // Sirf filled rooms filter karo
        const filledRooms = rooms.filter((room) => {
            const rates = roomRates[room.RoomID];
            return rates && Object.values(rates).some((v) => v !== "" && v !== undefined);
        });

        // ✅ Kitni rooms fill hain aur kaunsi
        // console.log("🏨 Total filled rooms:", filledRooms.length);
        // console.log("🏨 Filled rooms list:", filledRooms.map(r => ({ RoomID: r.RoomID, RoomName: r.RoomName })));

        // ✅ roomRates ka poora object dekho
        // console.log("📋 roomRates state:", roomRates);

        if (filledRooms.length === 0) {
            swal("Error", "Please fill rates for at least one room", "error");
            return;
        }

        try {
            setLoading(true);

            // Har room ke liye API call log karo
            const promises = filledRooms.map((room, index) => {
                const rates = roomRates[room.RoomID] || {};

                // ✅ Har room ke liye kya bheja ja raha hai
                // console.log(`🔄 API Call #${index + 1} for Room: "${room.RoomName}" (ID: ${room.RoomID})`, {
                //     PropID: selectedProperty?.PropertyID,
                //     RateCodeMealPlanID: 0,
                //     RateCodeID: selectedRate || 0,
                //     MealPlanID: selectedMealPlan,
                //     RoomTypeID: room.RoomID,
                //     rates,
                // });

                return ReservationSaveMapping(
                    selectedProperty?.PropertyID || 0,
                    0,
                    selectedRate || 0,
                    selectedMealPlan,
                    room.RoomID,
                    rates.BaseRate || 0,
                    rates.DoubleRate || 0,
                    rates.TripleRate || 0,
                    rates.ExtraBed || 0,
                    rates.ExtraAdultRate || 0,
                    rates.ExtraChildRate || 0,
                    effectiveFrom,
                    effectiveTo,
                    isActive ? 1 : 0
                );
            });

            // console.log(`🚀 Total API calls fired: ${promises.length}`);

            const results = await Promise.all(promises);

            // ✅ Saare results ek saath dekho
            // console.log("🎯 All API results:", results);

            if (onSaveSuccess) await onSaveSuccess();

            swal("Data Saved Successfully", {
                icon: "success",
                buttons: { confirm: { text: "OK", className: "btn btn-success" } },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById(modalId)
                );
                if (modal) modal.hide();
                resetForm();
            });

        } catch (error) {
            console.error("❌ handleSubmit Error:", error);
            swal("Failed to save data!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x" role="status"></div>
                </div>
            )}
            <div className="row rate-inventory-form">
                {Pms?.PMS === "Opera" && (
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Rate Code</label>
                            <select className="form-control form-select" value={selectedRate}
                                onChange={(e) => setSelectedRate(e.target.value)}>
                                <option value="">Select code</option>
                                {ratecode.map((item) => (
                                    <option key={item.RateCodeID} value={item.RateCodeID}>
                                        {item.Name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">Meal Plan</label>
                        <select className="form-control form-select" value={selectedMealPlan}
                            onChange={(e) => setSelectedMealPlan(e.target.value)}>
                            <option value="">Select Plan</option>
                            {mealplan.map((item) => (
                                <option key={item.MealPlanID} value={item.MealPlanID}>
                                    {item.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Har Room ka Card */}
                <div className="col-md-12">
                    {rooms.map((room) => (
                        <div key={room.RoomID} className="card mb-3 border shadow-sm">
                            <div className="card-header fw-bold">{room.RoomName}</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="mb-3">
                                            <label className="form-label">Base Rate</label>
                                            <input type="number" className="form-control" min={0}
                                                value={roomRates[room.RoomID]?.BaseRate || ""}
                                                onChange={(e) => handleRateChange(room.RoomID, "BaseRate", e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="mb-3">
                                            <label className="form-label">Double Rate</label>
                                            <input type="number" className="form-control" min={0}
                                                value={roomRates[room.RoomID]?.DoubleRate || ""}
                                                onChange={(e) => handleRateChange(room.RoomID, "DoubleRate", e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="mb-3">
                                            <label className="form-label">Triple Rate</label>
                                            <input type="number" className="form-control" min={0}
                                                value={roomRates[room.RoomID]?.TripleRate || ""}
                                                onChange={(e) => handleRateChange(room.RoomID, "TripleRate", e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="mb-3">
                                            <label className="form-label">Extra Bed</label>
                                            <input type="number" className="form-control" min={0}
                                                value={roomRates[room.RoomID]?.ExtraBed || ""}
                                                onChange={(e) => handleRateChange(room.RoomID, "ExtraBed", e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="mb-3">
                                            <label className="form-label">Extra Adult Rate</label>
                                            <input type="number" className="form-control" min={0}
                                                value={roomRates[room.RoomID]?.ExtraAdultRate || ""}
                                                onChange={(e) => handleRateChange(room.RoomID, "ExtraAdultRate", e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="mb-3">
                                            <label className="form-label">Extra Child Rate</label>
                                            <input type="number" className="form-control" min={0}
                                                value={roomRates[room.RoomID]?.ExtraChildRate || ""}
                                                onChange={(e) => handleRateChange(room.RoomID, "ExtraChildRate", e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="col-sm-6">
                    <div className="mb-3">
                        <label className="form-label">Effective From</label>
                        <input type="date" className="form-control" value={effectiveFrom}
                            onChange={(e) => setEffectiveFrom(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="mb-3">
                        <label className="form-label">Effective To</label>
                        <input type="date" className="form-control" value={effectiveTo}
                            onChange={(e) => setEffectiveTo(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="mb-3 d-flex align-items-center">
                        <label className="form-label me-2 mb-0">Active</label>
                        <input type="checkbox" checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)} />
                    </div>
                </div>
                <div className="col-sm-12 mt-3 text-end">
                    <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </div>
        </>
    );
};
